/* ============================================================
   theme.js · main module
   - smooth scroll
   - FAQ accordion
   - sticky header on scroll
   - mobile menu toggle
   - lazy load fallback
   ============================================================ */

(function () {
  'use strict';

  /* ---------- Smooth scroll for anchors ---------- */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href^="#"]');
    if (!a) return;
    const href = a.getAttribute('href');
    if (href === '#' || href.length < 2) return;
    const target = document.querySelector(href);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---------- FAQ accordion (one open at a time) ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-faq-toggle]');
    if (!btn) return;
    const item = btn.closest('[data-faq-item]');
    if (!item) return;
    const list = item.closest('[data-faq-list]');
    const willOpen = !item.classList.contains('is-open');

    if (list) {
      list.querySelectorAll('[data-faq-item].is-open').forEach((other) => {
        if (other === item) return;
        other.classList.remove('is-open');
        const t = other.querySelector('[data-faq-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
        const p = other.querySelector('[data-faq-panel]');
        if (p) p.hidden = true;
      });
    }

    item.classList.toggle('is-open', willOpen);
    btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    const panel = item.querySelector('[data-faq-panel]');
    if (panel) panel.hidden = !willOpen;
  });

  /* ---------- Sticky header (add .scrolled past 50px) ---------- */
  const header = document.querySelector('[data-site-header]');
  if (header) {
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        header.classList.toggle('scrolled', window.scrollY > 50);
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Mobile menu toggle ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-menu-toggle]');
    if (btn) {
      const open = !document.body.classList.contains('menu-open');
      document.body.classList.toggle('menu-open', open);
      document.querySelectorAll('[data-menu-toggle]').forEach((b) => {
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      return;
    }
    if (e.target.matches('[data-menu-backdrop]')) {
      document.body.classList.remove('menu-open');
      document.querySelectorAll('[data-menu-toggle]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    }
  });

  /* ---------- Lazy load fallback (older browsers) ---------- */
  if (!('loading' in HTMLImageElement.prototype) && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((ent) => {
        if (!ent.isIntersecting) return;
        const img = ent.target;
        if (img.dataset.src) { img.src = img.dataset.src; }
        if (img.dataset.srcset) { img.srcset = img.dataset.srcset; }
        io.unobserve(img);
      });
    }, { rootMargin: '200px 0px' });
    document.querySelectorAll('img[loading="lazy"][data-src]').forEach((img) => io.observe(img));
  }

  /* ---------- Sticky CTA mobile on product page ---------- */
  const stickyCta = document.querySelector('[data-sticky-cta]');
  const mainForm = document.querySelector('[data-product-main-form]');
  if (stickyCta && mainForm && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(([ent]) => {
      stickyCta.classList.toggle('is-visible', !ent.isIntersecting);
    }, { rootMargin: '0px 0px -100px 0px' });
    io.observe(mainForm);
  }

  /* ---------- Scroll reveal (fade + rise when entering viewport) ---------- */
  (function () {
    const items = document.querySelectorAll('[data-reveal]');
    if (!items.length) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-visible'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((ent) => {
        if (!ent.isIntersecting) return;
        ent.target.classList.add('is-visible');
        io.unobserve(ent.target);
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    items.forEach((el) => io.observe(el));
  })();

  /* ---------- Toast helper exposed globally ---------- */
  window.HP_toast = (msg) => {
    let el = document.querySelector('[data-toast]');
    if (!el) {
      el = document.createElement('div');
      el.setAttribute('data-toast', '');
      el.className = 'toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(window._hpToastT);
    window._hpToastT = setTimeout(() => el.classList.remove('is-visible'), 3000);
  };

})();
